
import { Component } from "@angular/core";
@Component({
  styleUrls: ["./system-overview.component.css"],
  templateUrl: "./system-overview.component.html",
})
export class SystemOverviewComponent {

}